type StepStatus = 'completed' | 'approval' | 'active' | 'pending';

export interface MigrationStep {
  label: string;
  status: StepStatus;
  description: string;
  subLabel?: string;
  midpointLabel?: string;
}

export const APPROVE_EXPORT_STEPS: MigrationStep[] = [
  { label: 'Export', status: 'completed', subLabel: 'Done', midpointLabel: 'Creating Transformations', description: 'Resources exported from the source org successfully' },
  { label: 'Transform', status: 'pending', description: 'Transformations will be applied to the exported resources' },
  { label: 'Import', status: 'pending', description: 'Resources will be imported into the target organization' },
  { label: 'Complete', status: 'pending', description: 'Migration will be marked complete' }
];

export const APPROVE_TRANSFORMATIONS_STEPS: MigrationStep[] = [
  { label: 'Export', status: 'completed', subLabel: 'Done', description: 'Resources exported from the source org successfully' },
  { label: 'Transform', status: 'completed', subLabel: 'Done', midpointLabel: 'Approving Transformations', description: 'Transformations applied to exported resources successfully' },
  { label: 'Import', status: 'pending', description: 'Resources will be imported into the target organization' },
  { label: 'Complete', status: 'pending', description: 'Migration will be marked complete' }
];
